import React from 'react';
import { createRoot } from 'react-dom/client';

import SignInForm from 'common/components/SignInForm';
import readAttribute, {
  readBooleanAttribute
} from 'common/tools/dom/readAttribute';

const init = () => {
  const anchor = document.getElementsByClassName('js-sign-in-form')[0];

  if (!anchor) return;

  const termsPolicyOnSignIn = readBooleanAttribute(
    anchor,
    'data-terms-policy-on-sign-in'
  );

  const redirectUrl = readAttribute<string, undefined>(
    anchor,
    'data-redirect-url'
  );
  const root = createRoot(anchor);
  root.render(
    <SignInForm
      redirectUrl={redirectUrl}
      termsPolicyOnSignIn={termsPolicyOnSignIn}
    />
  );
};

export default init;
